import styled from 'styled-components';

export const RegisterInfoLink = styled.p`
  text-align: center;
  margin-top: 10px;

  a {
    text-decoration: underline;
    color: #f36c1b;
    margin-left: 5px;
  }
`;

export const ForgetPasswordLink = styled.a`
  color: gray;
  font-size: 0.8rem;
  margin: 0.4rem;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const SignupText = styled.span`
  font-weight: normal;
  font-size: 16px;
  color: #4f4f4f;
  text-align: center;
  margin-top: 16px;

  a {
    color: #000000;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;
